/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react';
import { ShimmerButton, ShimmerText, ShimmerTitle } from 'react-shimmer-effects';
import { Skeleton } from 'react-skeleton-generator';

function ViewDapSkeleton() {
    return (
        <Skeleton.SkeletonThemeProvider highlight="light">
            <div className="py-6 pl-12 pr-[77px] main-screen">
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <a href="Freight-Policy(DAP)-list.html">
                            <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                        </a>
                        <h5 className="text-xs4 font-normal text-[#555259]">View Freight Policy (DAP)</h5>
                    </div>
                    <div>
                        <a href="">
                            <ShimmerButton size="md" />
                        </a>
                    </div>
                </div>
                <div className="px-4 pt-[34px]">
                    <div className="w-[90%]">
                        <ShimmerTitle line={2} gap={10} variant="primary" className="w-1/4" />
                    </div>
                    <div className="flex -mx-2 mt-8">
                        <div className="px-2 w-[18%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" className="h-5" /></p>
                            {' '}
                            {/* <p className="text-lg font-normal text-[#090406] pt-1.5"><ShimmerText line={1} gap={3} variant="primary" /></p> */}
                        </div>
                        <div className="px-2 w-[18%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>
                        </div>
                        <div className="px-2 w-[18%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>
                        </div>
                        <div className="px-2 w-[18%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>
                        </div>
                    </div>
                    <div className="flex -mx-2 mt-4">
                        <div className="px-2 w-[18%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>
                        </div>
                        <div className="px-2 w-[18%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>
                        </div>
                        <div className="px-2 w-[25.28%]">
                            <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>
                        </div>
                    </div>
                    <div className="mt-8 w-full">
                        <div className="mt-2 rounded-[22px] bg-[#F5F5FA] px-2.5 py-2.5 w-full">
                            <div>
                                <div className="bg-[#ffffff] rounded-[16px] px-[22px] pt-4 pb-4">
                                    <div className="px-3.5">
                                        <div className="flex -mx-2 w-[90%]">
                                            <div className="px-2 w-1/4">
                                                <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                            </div>
                                            <div className="px-2 w-1/4">
                                                <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                            </div>
                                            <div className="px-2 w-1/4">
                                                <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                            </div>
                                            <div className="px-2 w-1/4">
                                                <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex -mx-2 pb-2.5 flex-wrap">
                                        {[...Array(3)].map((item) => (
                                            <div className="px-2 mt-[22px]" key={item}>
                                                <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                            </div>
                                        ))}

                                    </div>
                                    <div className="rounded-lg bg-[#F5F5FA] px-3.5 py-8 w-[90%]">
                                        <div className="flex -mx-2">
                                            <div className="px-2 w-1/4">
                                                <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                            </div>
                                            <div className="px-2 w-1/4">
                                                <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-7 pb-2.5" />
                        </div>
                    </div>
                    <div className="mt-[22px] w-[392px]">
                        <h5 className="text-sm font-bold text-[#090406]">Activity Log</h5>
                        <div className="mt-2 rounded-[22px] bg-[#F5F5FA] p-[15px] w-full">
                            <div className="bg-[#ffffff] rounded-[16px] px-[19px] pt-[13px] pb-6">
                                <div>
                                    <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                </div>
                                <div className="pt-3.5">
                                    <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                </div>
                                <div className="pt-3.5">
                                    <p className="text-xs2 font-semibold text-[#808285]"><ShimmerText line={2} gap={10} variant="primary" /></p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Skeleton.SkeletonThemeProvider>

    );
}

export default ViewDapSkeleton;
